// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__3Sxky","footer":"Services_footer__2brcX"};